module.exports = __webpack_public_path__ + "img/login_img_1.ca9adcaf.png";